module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc27",
      "id": "dd27"
    }
  }, [_c('i', [_vm._v("January 25")])])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary25"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0030-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("The righteousness of God, through faith in Jesus Christ, to all and on all who believe.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0030-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("H")]), _vm._v("e made Him who knew no sin to be sin for us, that we might become the righteousness of God in Him. • Christ has redeemed us from the curse of the law, having become a curse for us. • Christ Jesus . . . became for us wisdom from God—and righteousness and sanctification and redemption. • Not by works of righteousness which we have done, but according to His mercy He saved us, through the washing of regeneration and renewing of the Holy Spirit, whom He poured out on us abundantly through Jesus Christ our Savior.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-05-7"
    }
  }, [_vm._v("I also count all things loss for the excellence of the knowledge of Christ Jesus my Lord, for whom I have suffered the loss of all things, and count them as rubbish, that I may gain Christ and be found in Him, not having my own righteousness, which is from the law, but that which is through faith in Christ, the righteousness which is from God by faith.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 3:22; 2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 5:21; G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AL")]), _vm._v(". 3:13; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 1:30; T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITUS")]), _vm._v(" 3:5–6; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 3:8–9")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary25"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0030-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("The Spirit of adoption by whom we cry out, “Abba, Father.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0030-09-13"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("J")]), _vm._v("esus . . . lifted up His eyes to heaven, and said: “Father. . . . Holy Father. . . . O righteous Father!” • He said, “Abba, Father.” • Because you are sons, God has sent forth the Spirit of His Son into your hearts, crying out, “Abba, Father!” • For through Him we both have access by one Spirit to the Father. Now, therefore, you are no longer strangers and foreigners, but fellow citizens with the saints and members of the household of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-10-18"
    }
  }, [_vm._v("Doubtless You are our Father. . . . You, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", are our Father; our Redeemer from Everlasting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-10-19"
    }
  }, [_vm._v("“I will arise and go to my father, and will say to him, ‘Father, I have sinned against heaven and before you, and I am no longer worthy to be called your son. Make me like one of your hired servants.’” And he arose and came to his father.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-10-20"
    }
  }, [_vm._v("Therefore be imitators of God as dear children.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 8:15; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 17:1, 11, 25; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" 14:36; G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AL")]), _vm._v(". 4:6; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 2:18–19; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 63:16; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 15:18–20; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 5:1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b352a466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter27.vue
// module id = 144
// module chunks = 0